<template>
  <span>
    <div class="mb-3 vx-row">
      <div id="customer_details" class="w-full vx-col">
        <vx-card>
          <div class="w-full con-expand-users">
            <div class="flex items-center justify-between con-btns-user">
              <div class="flex items-center justify-start con-userx">
                <vs-avatar color="primary" :text="tenant && tenant.name" />
                <span class="font-semibold text-primary">
                  {{ tenant && tenant.name }}
                  ( {{ tenant && tenant.account_number }} )
                </span>
              </div>
              <div class="flex">
                <vs-button class="mr-2" @click.stop="onClockLoginAsL2()" color="success" type="filled" icon-pack="feather"
                  icon="icon-user">
                  Navigate & Login as L2 user
                </vs-button>
                <vs-button @click.stop="onClickNavigateToTenant()" color="success" type="border" icon-pack="feather"
                  icon="icon-navigation">
                  Navigate to L2 portal
                </vs-button>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-row">
      <div class="w-full vx-col">
        <vs-tabs :value="active_step" :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none"
          id="profile-tabs" :key="isSmallerScreen">
          <vs-tab icon-pack="feather" icon="icon-user" :label="!isSmallerScreen ? 'Company profile' : ''">
            <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
              <tenant-details-view :tenant="tenant" />
            </div>
          </vs-tab>
          <vs-tab icon-pack="feather" icon="icon-users" :label="!isSmallerScreen ? 'L2 users' : ''">
            <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
              <tenant-users />
            </div>
          </vs-tab>
          <vs-tab icon-pack="feather" icon="icon-credit-card" :label="!isSmallerScreen ? 'Souqbox commercial' : ''">
            <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
              <tenant-commercial />
            </div>
          </vs-tab>
          <vs-tab icon-pack="feather" icon="icon-dollar-sign" :label="!isSmallerScreen ? 'Invoices' : ''">
            <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
              <tenant-invoice />
            </div>
          </vs-tab>
          <vs-tab icon-pack="feather" icon="icon-settings" :label="!isSmallerScreen ? 'Settings' : ''">
            <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
              <tenant-settings-view />
            </div>
          </vs-tab>

          <vs-tab icon-pack="feather" icon="icon-award" :label="!isSmallerScreen ? 'Branding' : ''">
            <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
              <branding />
            </div>
          </vs-tab>
          <vs-tab icon-pack="feather" icon="icon-hash" :label="!isSmallerScreen ? 'Number Sequence' : ''">
            <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
              <number-sequence />
            </div>
          </vs-tab>
          <vs-tab icon-pack="feather" icon="icon-users" :label="!isSmallerScreen ? 'RM Suppliers' : ''">
            <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
              <manage-suppliers />
            </div>
          </vs-tab>
          <vs-tab icon-pack="feather" icon="icon-users" :label="!isSmallerScreen ? 'Channel Partners' : ''">
            <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
              <channel-partners-list />
            </div>
          </vs-tab>
          <vs-tab icon-pack="feather" icon="icon-download-cloud" :label="!isSmallerScreen ? 'Bulk Upload Templates' : ''">
            <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
              <BulkUploadTemplates/>
            </div>
          </vs-tab>
          <!-- <vs-tab icon-pack="feather" icon="icon-users" :label="!isSmallerScreen ? 'Language Settings' : ''">
              <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
                <LanguageList/>
              </div>
          </vs-tab> -->
        </vs-tabs>
      </div>
    </div>
  </span>
</template>

<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";
import TenantDetailsView from "@/views/pages/tenants/tabs/TenantDetailsView";
import TenantCommercial from "@/views/pages/tenants/tabs/TenantCommercial";
import TenantInvoice from "@/views/pages/tenants/tabs/TenantInvoice";
import TenantUsers from "@/views/pages/tenants/tabs/TenantUsers";
import TenantSettingsView from "@/views/pages/tenants/tabs/TenantSettingsView";
import Branding from "@/views/pages/tenants/tabs/Branding";
import NumberSequence from "@/views/pages/tenants/tabs/NumberSequence";
import ManageSuppliers from "./tabs/ManageSuppliers.vue";
import ChannelPartnersList from './tabs/ChannelPartnersList.vue'
import BulkUploadTemplates from './tabs/BulkUploadTemplates.vue'
import LanguageList from './tabs/localizations/LanguageList.vue'
import { APP_LEVEL_2_URL, APP_DEMO_TENANT_AUTH_PAGE } from "@/constants/config";

import ErrorMessages from '@/mixins/ErrorMessages'

const tenantRepository = RepositoryFactory.get('tenant')

export default {
  name: "TenantDetailsTabs",
  data() {
    return {
      active_step: this.$route.query.step ? this.$route.query.step : '0',
      tenantId: '',
      tenant: {}
    }
  },
  mixins: [ErrorMessages],
  components: {
    Branding,
    NumberSequence,
    TenantSettingsView,
    TenantInvoice,
    TenantDetailsView,
    TenantCommercial,
    TenantUsers,
    ManageSuppliers,
    ChannelPartnersList,
    LanguageList,
    BulkUploadTemplates
  },
  async mounted() {
    this.tenantId = this.$route.params.id
    await this.fetchTenant()
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768
    }
  },
  methods: {
    async fetchTenant() {
      try {
        const { data } = (await tenantRepository.getTenantDetails(this.tenantId)).data;
        this.tenant = data;
        console.log("tenant details", this.tenant)
      } catch (error) {
        this.convertAndNotifyError(error)
      }
    },
    onClickNavigateToTenant() {
      window.open(`https://${this.tenant.domain}.${APP_LEVEL_2_URL}/`, '_blank');
    },
    async onClockLoginAsL2() {
      try {
        const { data } = (await tenantRepository.loginAsL2User(this.tenantId)).data;
        console.log(data.token);
        window.open(`https://${this.tenant.domain.split(".")[0]}.${APP_LEVEL_2_URL}${APP_DEMO_TENANT_AUTH_PAGE}${data.token}`)
      } catch (error) {
        this.convertAndNotifyError(error)
      }
    }
  }
}
</script>

<style scoped></style>
